module.exports = __webpack_public_path__ + "img/jsilva.9a96697a.jpg";